import { createFileRoute } from '@tanstack/react-router'
import { ViewerRouteNavigator } from 'pages/viewer/ViewerRouteNavigator'

export const Route = createFileRoute('/viewer/$unitID/')({
  component: OutletComponent,
})

function OutletComponent() {
  const { unitID } = Route.useParams()
  const navigate = Route.useNavigate()
  return (
    <ViewerRouteNavigator
      unitID={unitID}
      navigate={navigate}
      preferredEndpoint={undefined}
    />
  )
}
